__turbopack_context__.v({
  "body": "FiltersSidePanel-module-scss-module__YpWWPW__body",
  "clearAllBtn": "FiltersSidePanel-module-scss-module__YpWWPW__clearAllBtn",
  "footer": "FiltersSidePanel-module-scss-module__YpWWPW__footer",
  "header": "FiltersSidePanel-module-scss-module__YpWWPW__header",
  "headerTitle": "FiltersSidePanel-module-scss-module__YpWWPW__headerTitle",
  "root": "FiltersSidePanel-module-scss-module__YpWWPW__root",
});
